import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import routesMap from 'src/js/router/helpers/routes-map';
import redirectUnauthorizedUser from 'src/js/helpers/redirect-unauthorized-user';
import { SiteSetupContext } from '../helpers/site-setup-context';
import getUserAuthorizationStatus from '../../user/selectors/user-authorization-status';
import getSiteIdToSwitch from '../../sites/selectors/site-id-to-switch-template';
import getSiteIdToRecreate from '../../sites/selectors/get-site-id-recreate';
import trackers from '../../analytics/segment/trackers';

const { trackUseTemplateButtonClicked } = trackers;

const useOnTemplateSelect = ({ isTrackEventsAsync = false } = {}) => {
  const isUserAuthenticated = useSelector(getUserAuthorizationStatus);
  const siteIdToSwitch = useSelector(getSiteIdToSwitch);
  const siteIdToRecreate = useSelector(getSiteIdToRecreate);
  const siteId = siteIdToRecreate || siteIdToSwitch || null;
  const context = useContext(SiteSetupContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { updateData, getData } = context;
  const { businessCategorySlug } = getData();

  const onTemplateSelect = useCallback(
    async (templateSlug, triggerId) => {
      updateData({
        templateSlug,
      });

      await trackUseTemplateButtonClicked(
        {
          siteId,
          templateBuildSlug: templateSlug,
          businessCategory: businessCategorySlug,
          triggerId,
        },
        isTrackEventsAsync
      );

      if (isUserAuthenticated) {
        if (siteIdToSwitch) {
          navigate(routesMap.createSite.url({ currentPath: location.pathname }), { replace: true });
        } else {
          navigate(routesMap.siteName.url());
        }
      } else {
        redirectUnauthorizedUser();
      }
    },
    [
      updateData,
      siteId,
      businessCategorySlug,
      isTrackEventsAsync,
      isUserAuthenticated,
      siteIdToSwitch,
      navigate,
      location,
    ]
  );

  return onTemplateSelect;
};

export default useOnTemplateSelect;
